import linkedin from "../assets/linkedin.png";
import insta from "../assets/instagram.png";
import youtube from "../assets/youtube.png";
import { X7PM_URL } from "../config/links";

export default function Footer() {
  return (
    <footer className="bg-gray-200 py-12 px-6 md:px-16">
      <div className="grid grid-cols-1 md:grid-cols-4 gap-10">

        {/* Connect With Us */}
        <div>
          <h3 className="text-lg font-semibold mb-4">Connect with us!</h3>
          <p className="flex items-center gap-2">
            <span>📧</span>
            <a
              href="mailto:hr@x7ittechnologies.com"
              className="hover:underline hover:text-orange-500 transition-colors duration-200 leading-relaxed break-words break-all"
            >
              hr@x7ittechnologies.com
            </a>
          </p>
          <p className="flex items-center gap-2 mt-2">
            <span>📞</span> +91 7204439777
          </p>
          <div className="flex gap-4 mt-4">
            <a href="https://www.linkedin.com/company/x7-it-technologies/"><img src={linkedin} alt="LinkedIn" className="h-8 w-8" /></a>
            <img src={insta} alt="insta" className="h-8 w-8" />
            <img src={youtube} alt="youtube" className="h-8 w-8" />
          </div>

        </div>

        {/* Quick Links */}
        <div>
          <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
          <ul className="space-y-2">
            <li><a href="/" className="hover:underline">Home</a></li>
            <li><a href="/about" className="hover:underline">About us</a></li>
            <li><a href="/services" className="hover:underline">Services</a></li>
            <li><a href="/products" className="hover:underline">Products</a></li>
            <li><a href="/contact" className="hover:underline">Contact</a></li>
          </ul>
        </div>

        {/* Our Branches */}
        <div>
          <h3 className="text-lg font-semibold mb-4">Our Branches</h3>
          <div className="space-y-4 text-sm">
            <div>
              <p className="font-medium">Belagavi, India:</p><br/>
              <p>X7 IT Technologies, <br/>Block No-301, Balaji Heights Jay Nagar, Belagavi, Karnataka, 591108</p>
            </div>
            <div>
              <p className="font-medium">UP Comming Branch <br></br> <br></br>Bangalore, India:</p><br/>
            </div>
          </div>
        </div>

        {/* Google Map */}
        <div>
          <h3 className="text-lg font-semibold mb-4">Our Location</h3>
          <div className="w-full h-40 rounded-lg overflow-hidden shadow">
            <iframe title="X7 IT Technologies location" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3348.0273261468587!2d74.48344567447631!3d15.870320484780754!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bbf656008761ea1%3A0x7699c17559d622c8!2sX7%20DIGI%20ADS!5e1!3m2!1sen!2sin!4v1759770323046!5m2!1sen!2sin" width="600" height="450"  allowfullscreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>
          </div>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className="border-t border-gray-300 mt-10 pt-6 flex flex-col md:flex-row justify-between items-start md:items-center gap-4 text-sm">
        <p><a href="https://x7ittechnologies.com" className="hover:text-blue-700 transition-colors duration-300">© X7 IT Technologies</a> 2025 All rights reserved</p>
        <div className="flex flex-wrap items-center gap-6">
          <a href="#" className="hover:underline">Privacy Policy</a>
          <a href="#" className="hover:underline">Terms &amp; Conditions</a>

          {/* X7 PM — internal Project Management / CRM / Payroll platform.
              This footer link is the ONLY entry point to X7 PM from the website.
              It opens in a new tab so the marketing site stays open behind it.
              URL comes from REACT_APP_X7PM_URL in .env (see src/config/links.js). */}
          <a
            href={X7PM_URL}
            target="_blank"
            rel="noopener noreferrer"
            title="Open X7 PM — Project Management, CRM & Payroll (opens in a new tab)"
            aria-label="Open X7 PM in a new tab"
            className="inline-flex items-center gap-2 rounded-full border border-gray-400 px-4 py-1.5 font-medium text-gray-700 hover:border-orange-500 hover:text-orange-500 hover:shadow-sm transition-all duration-200"
          >
            <span>X7 PM</span>
            {/* external-link icon */}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="h-3.5 w-3.5"
              aria-hidden="true"
            >
              <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
              <polyline points="15 3 21 3 21 9" />
              <line x1="10" y1="14" x2="21" y2="3" />
            </svg>
          </a>
        </div>
      </div>
    </footer>
  );
}
